import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  TAppIdentifier,
  TBctxItemWithoutSize,
  TBCTXKeys,
  TBCTXKeysWithoutSize,
  TBulkCountAppEventWithStatus,
  TFailureInfo,
  TSingleCountEvent,
  TSizeQuantity,
} from '@monorepo/types';
import { BulkCountAppComputationHelper } from '@monorepo/utils';
import produce from 'immer';
import * as _ from 'lodash';
type TFailedRow = {
  bctxStringWithoutSize: string;
  sizeFailures: TSizeQuantity[];
};
@Component({
  selector: 'monorepo-validation-error-modal',
  templateUrl: './validation-error-modal.component.html',
  styleUrls: ['./validation-error-modal.component.scss'],
})
export class ValidationErrorModalComponent implements OnInit {
  @Input() bctxKeysToDisplayMap!: Record<TBCTXKeys, string>;
  failedEventsVM: TFailedRow[] = [];
  @Input() failedEvents: TBulkCountAppEventWithStatus[] = [];
  constructor(private modalCtrl: ModalController) {}

  dismissModal() {
    this.modalCtrl.dismiss();
  }

  ngOnInit(): void {
    this.failedEventsVM = [];
    this.failedEvents.forEach(({ event }) => {
      const preSizeLevelErrorsString = event.metaData.bctxWithoutSize
        .map((curr) => {
          return `${this.bctxKeysToDisplayMap[curr.k]}: ${curr.v}`;
        })
        .join(', ');
      this.failedEventsVM.push({
        bctxStringWithoutSize: preSizeLevelErrorsString,
        sizeFailures: event.sizeQuantities,
      });
    });
  }
}
